import { Space } from "antd";
import { EntityLabel } from "components/Shared/Labels/EntityLabel";
import { RosterAndStaffButton } from "components/Shared/RosterAndStaffButton";
import { useSharedColumnBuilder } from "hooks/useSharedColumnBuilder";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { DeleteTaskButton } from "../components/DeleteTaskButton";

export const useAdminSeasonsColumns = () => {
  const { formatMessage } = useIntl();
  const {
    createCompetitionNameColumn,
    createSeasonNameColumn,
    createSeasonStartDateColumn,
    createSeasonEndDateColumn,
    createTaskStatusColumn,
    createIsRegistrationOpen,
  } = useSharedColumnBuilder();

  return [
    createCompetitionNameColumn(),
    createSeasonNameColumn(),
    {
      title: formatMessage({ id: "columns.season.entityName" }),
      dataIndex: "entityNameLocal",
      width: 200,
      render: (value, record) => <EntityLabel title={value} imageUrl={record?.entityImageLogoUrl} />,
    },
    createSeasonStartDateColumn(),
    createSeasonEndDateColumn(),
    createIsRegistrationOpen(),
    createTaskStatusColumn(),
    {
      align: "right",
      render: (_, record: any) => (
        <Space>
          <Link to={`entities/${record.entityId}/seasons/${record.seasonId}`}>
            <RosterAndStaffButton />
          </Link>
          <DeleteTaskButton entityId={record.entityId} seasonId={record.seasonId} />
        </Space>
      ),
      width: 250,
    },
  ];
};
